import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreUiModule } from '@exl-ng/core-ui';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { OrderItComponent } from './order-it/order-it-component/order-it.component';
import { OrderItSuccessMessageComponent } from './order-it/order-it-success-message-component/order-it-success-message.component';
import { OrderItFailureMessageComponent } from './order-it/order-it-failure-message-component/order-it-failure-message.component';
import { OrderItNotAuthorizedComponent } from './order-it/order-it-not-authorized-component/order-it-not-authorized.component';
import {RequestItComponent} from './request-it/request-it-component/request-it.component';
import {
  RequestItMessageComponent
} from './request-it/request-it-component/request-it-message-component/request-it-message.component';
import { OrderItNotLoggedInComponent } from './order-it/order-it-not-logged-in/order-it-not-logged-in.component';
import {RequestItCheckboxComponent} from './request-it/request-it-component/request-it-checkbox-component/request-it-checkbox-component';

@NgModule({
  declarations: [
    AppComponent,
    OrderItComponent,
    OrderItSuccessMessageComponent,
    OrderItFailureMessageComponent,
    OrderItNotAuthorizedComponent,
    RequestItComponent,
    RequestItMessageComponent,
    RequestItCheckboxComponent,
    OrderItNotLoggedInComponent
  ],
  imports: [
    CoreUiModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
